import React from 'react'
import { useDispatch } from 'react-redux'
import map from 'lodash/map'
import AccountUserWorkspaceRow from './AccountUserWorkspaceRow'
import classnames from 'classnames'

import {
  IAccountUser
} from '@SiteModules/AccountUser/types'

import {
  deleteWorkspaceUser,
} from '@SiteModules/WorkspaceUser/actions'

import './AccountUserWorkspacesTable.scss'

interface AccountUserWorkspacesTableProps {
  readonly accountUser: IAccountUser
  readonly fullAccountUserView: boolean
}

const AccountUserWorkspacesTable: React.FC<AccountUserWorkspacesTableProps> = props => {
  const dispatch = useDispatch()

  const { accountUser, fullAccountUserView } = props

  const renderTableHeader = () => {
    return (
      <tr>
        <th className="AccountUserWorkspacesTable__workspace-name">
          Workspace
        </th>
        <th className="AccountUserWorkspacesTable__access">
          Access
        </th>
      </tr>
    )
  }

  const workspaceRows = map(accountUser.workspaceUsers, (workspaceUser, index) => {
    const handleDeleteWorkspaceUser = () => {
      dispatch(deleteWorkspaceUser({ workspaceUserId: workspaceUser.id }))
    }

    return (
      <AccountUserWorkspaceRow
        key={index + 1}
        index={index + 1}
        workspaceUser={workspaceUser}
        deleteWorkspaceUser={handleDeleteWorkspaceUser}
      />
    )
  })

  return (
    <div
      className={classnames(
        'AccountUserWorkspacesTable',
        { 'AccountUserWorkspacesTable__full': fullAccountUserView}
      )}
    >
      <table>
        <thead>
          {renderTableHeader()}
        </thead>
        <tbody
          className={classnames(
            'AccountUserWorkspacesTable__body',
            { 'AccountUserWorkspacesTable__body-full': fullAccountUserView }
          )}
        >
          {workspaceRows}
        </tbody>
      </table>
    </div>
  )
}

export default AccountUserWorkspacesTable
